import { render, staticRenderFns } from "./AddictiveStuffClientsHabits.vue?vue&type=template&id=8225fc70&"
import script from "./AddictiveStuffClientsHabits.vue?vue&type=script&lang=js&"
export * from "./AddictiveStuffClientsHabits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports